import React from "react";
import OtpInput from "react-otp-input";

const OTP = ({ value, handleChange, inputStyle, type = "password" }) => {
  const handleNumericChange = (otpValue) => {
    const numericValue = otpValue.replace(/[^0-9]/g, "");
    handleChange(numericValue);
  };

  return (
    <div className="w-full flex justify-center mt-10 sm:mt-7 lg:mt-[7%]">
      <OtpInput
        value={value}
        onChange={handleNumericChange}
        numInputs={6}
        renderInput={(props, index) => (
          <>
            <input
              {...props}
              type={type}
              inputMode="numeric"
              pattern="[0-9]*"
              style={{ ...(props?.style||{}) }}
            />
            {index === 2 && (
              <span
                aria-hidden="true"
                style={{
                  width: 9,
                  height: 24,
                  lineHeight: "24px",
                  marginLeft: -6,
                  marginRight: -6,
                  display: "inline-block",
                  textAlign: "center",
                  color: "#000000",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 400,
                  fontSize: 16,
                }}
              >
                -
              </span>
            )}
          </>
        )}
        isInputNum={true}
        shouldAutoFocus={true}
        inputStyle={inputStyle}
        focusStyle={{ outline: "none", boxShadow: "none" }}
        containerStyle={{
          gap: "10px",
        }}
      />
    </div>
  );
};

export default OTP;
